/**
 * 路口信息实体
 * zxw
 * 2024-05-20
 */
import React, { Component } from 'react';
import { Modal, Input,Row,Col, 
    message, InputNumber, Button,
    Radio, } from 'antd';
import $ from 'jquery';
import { AddRequestHeaders } from '../../incs/FunHelper';
import CNF from '../../incs/Config';

const MODULENAME = '路口';
const YEAR = new Date().getFullYear();

const { TextArea } = Input;

class Entity extends Component{
    constructor(props){
        super(props);
        this.state = {
            loading: false,
            ulid: '',
            number: '',
            name: '',
            fullName: '',
            structure: '',
            type: '',
            bootTime: '06:00',
            shutdownTime: '23:00',
            yellowLightDuration: 3,
            createYear: YEAR,
            hostMachine: '',
            hostMachineModel: '',
            hostMachineIsNetworking: 1,
            hostMachineProductNumber: '',
            hostMachineIcode: '',
            hostMachineIp: '',
            hostMachinePort: '',
            chassis: '',
            isUpsPowerSupply: 1,
            operator: '',
            detachment: '',
            region: '',
            road: '',
            longitude: '',
            latitude: '',
            description: '',
        }
    }

    changeNumber = (e) =>{this.setState({number: e.target.value.replace(' ','')});}
    changeName = (e) =>{this.setState({name: e.target.value});}
    changeFullName = (e) =>{this.setState({fullName: e.target.value});}
    changesStructure = (e) =>{this.setState({structure: e.target.value.replace(' ','')});}
    changeType = (e) =>{this.setState({ type: e.target.value.replace(' ','')});}
    changeBootTime = (e) =>{this.setState({ bootTime: e.target.value.replace(' ','')});}
    changeShutdownTime = (e) =>{this.setState({ shutdownTime: e.target.value.replace(' ','')});}
    changeYellowLightDuration = (value) =>{this.setState({ yellowLightDuration: value});}
    changeCreateYear = (value) =>{this.setState({ createYear: value});}
    changeHostMachine = (e) =>{ this.setState({ hostMachine: e.target.value.replace(' ','')});}
    changeHostMachineModel = (e) =>{ this.setState({ hostMachineModel: e.target.value.replace(' ','')});}
    changeHostMachineIsNetworking = (e) =>{ this.setState({ hostMachineIsNetworking: e.target.value});}
    changeHostMachineProductNumber = (e) =>{ this.setState({ hostMachineProductNumber: e.target.value.replace(' ','')});}
    changeHostMachineIcode = (e) =>{ this.setState({ hostMachineIcode: e.target.value.replace(' ','')});}
    changeHostMachineIp = (e) =>{ this.setState({ hostMachineIp: e.target.value.replace(' ','')});}
    changeHostMachinePort = (e) =>{ this.setState({ hostMachinePort: e.target.value.replace(' ','')});}
    changeChassis = (e) =>{ this.setState({ chassis: e.target.value.replace(' ','')});}
    changeIsUpsPowerSupply = (e) =>{ this.setState({ isUpsPowerSupply: e.target.value});}
    changeOperator = (e) =>{ this.setState({ operator: e.target.value.replace(' ','')});}
    changeDetachment = (e) =>{ this.setState({ detachment: e.target.value.replace(' ','')});}
    changeRegion = (e) =>{ this.setState({ region: e.target.value.replace(' ','')});}
    changeRoad = (e) =>{ this.setState({ road: e.target.value.replace(' ','')});}
    changeLongitude = (e) =>{this.setState({longitude: e.target.value});}
    changeLatitude = (e) =>{this.setState({latitude: e.target.value});}
    changeDescription = (e) =>{this.setState({description: e.target.value});}

    create = () =>{
        const _this = this;

        //  执行创建
        $.ajax({
            url: `${CNF.api}intersections`,
            headers: AddRequestHeaders(),
            type: 'POST',
            dataType: 'JSON',
            data:JSON.stringify({
                'number': this.state.number,
                'name': this.state.name,
                'full_name': this.state.fullName,
                'structure': this.state.structure,
                'type': this.state.type,
                'brand': this.state.brand,
                'boot_time': this.state.bootTime,
                'shutdown_time': this.state.shutdownTime,
                'yellow_light_duration': this.state.yellowLightDuration,
                'host_machine': this.state.hostMachine,
                'host_machine_model': this.state.hostMachineModel,
                'host_machine_is_networking': this.state.hostMachineIsNetworking,
                'host_machine_product_number': this.state.hostMachineProductNumber,
                'host_machine_icode': this.state.hostMachineIcode,
                'host_machine_ip': this.state.hostMachineIp,
                'host_machine_port': this.state.hostMachinePort,
                'chassis': this.state.chassis,
                'is_ups_power_supply': this.state.isUpsPowerSupply,
                'detachment': this.state.detachment,
                'region': this.state.region,
                'road': this.state.road,
                'operator': this.state.operator,
                'create_year': this.state.createYear,
                'longitude': this.state.longitude,
                'latitude': this.state.latitude,
                'description': this.state.description,
            }),success:function(data){
                if(data.res === 0){
                    message.success(data.msg, 1);
                    setTimeout(function(){
                        _this.handleCancel();
                        _this.props.isRefresh();
                    }, 1500);
                }else{
                    message.error(data.msg, 1.5);
                    _this.setState({loading: false});
                }
            }
        });
    };

    update = () =>{
        const _this = this;

        //  执行更新
        $.ajax({
            url: `${CNF.api}intersections/${this.state.ulid}`,
            headers: AddRequestHeaders(),
            type: 'PUT',
            dataType: 'JSON',
            data:JSON.stringify({
                'action': 'UPDATE',
                'number': this.state.number,
                'name': this.state.name,
                'full_name': this.state.fullName,
                'structure': this.state.structure,
                'type': this.state.type,
                'brand': this.state.brand,
                'boot_time': this.state.bootTime,
                'shutdown_time': this.state.shutdownTime,
                'yellow_light_duration': this.state.yellowLightDuration,
                'host_machine': this.state.hostMachine,
                'host_machine_model': this.state.hostMachineModel,
                'host_machine_is_networking': this.state.hostMachineIsNetworking,
                'host_machine_product_number': this.state.hostMachineProductNumber,
                'host_machine_icode': this.state.hostMachineIcode,
                'host_machine_ip': this.state.hostMachineIp,
                'host_machine_port': this.state.hostMachinePort,
                'chassis': this.state.chassis,
                'is_ups_power_supply': this.state.isUpsPowerSupply,
                'detachment': this.state.detachment,
                'region': this.state.region,
                'road': this.state.road,
                'operator': this.state.operator,
                'create_year': this.state.createYear,
                'longitude': this.state.longitude,
                'latitude': this.state.latitude,
                'description': this.state.description,
            }),success:function(data){
                if(data.res === 0){
                    message.success(data.msg, 1);
                    setTimeout(function(){
                        _this.handleCancel();
                        _this.props.isRefresh();
                    }, 1500);
                }else{
                    message.error(data.msg, 1.5);
                    _this.setState({loading: false});
                }
            }
        });
    };

    handleOk = () =>{
        //  参数校验
        if(this.state.number === ''){
            message.error('路口编码不能为空！');
            return;
        }
        if(this.state.name === ''){
            message.error('路口简称不能为空！');
            return;
        }
        if(this.state.fullName === ''){
            message.error('路口全称不能为空！');
            return;
        }
        // 校验开机与关机时间
        let regex = /^([0-2][0-9]):[0-6][0-9]$/;
        if(!regex.test(this.state.bootTime)){
            message.error('开机时间格式错误！');
            return;
        }
        if(!regex.test(this.state.shutdownTime)){
            message.error('关机时间格式错误！');
            return;
        }
        // IP地址格式验证
        regex = /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
        if(this.state.hostMachineIp && !regex.test(this.state.hostMachineIp)){
            message.error('主机地址格式错误！');
            return;
        }
        //  端口格式验证
        regex = /^(?:65535|65534|[1-9]\d{0,4})$/;
        if(this.state.hostMachinePort && !regex.test(this.state.hostMachinePort)){
            message.error('主机端口格式错误！');
            return;
        }
        this.setState({loading: true});
        if (this.props.record){
            this.update();
        }else{
            this.create();
        }
    };
    
    handleCancel = () =>{
        this.props.setIsModalOpen(false);
        this.setState({
            loading: false,
            ulid: '',
            number: '',
            name: '',
            fullName: '',
            structure: '',
            type: '',
            bootTime: '06:00',
            shutdownTime: '23:00',
            yellowLightDuration: 3,
            createYear: YEAR,
            hostMachine: '',
            hostMachineModel: '',
            hostMachineIsNetworking: 1,
            hostMachineProductNumber: '',
            hostMachineIcode: '',
            hostMachineIp: '',
            hostMachinePort: '',
            chassis: '',
            isUpsPowerSupply: 1,
            operator: '',
            detachment: '',
            region: '',
            road: '',
            longitude: '',
            latitude: '',
            description: '',
        });
    };

    componentDidUpdate(){
        if (this.props.record && this.state.ulid !== this.props.record.key){
            this.setState({
                record: this.props.record,
                ulid: this.props.record.key,
                number: this.props.record.number,
                name: this.props.record.name,
                fullName: this.props.record.full_name,
                structure: this.props.record.structure,
                type: this.props.record.type,
                bootTime: this.props.record.boot_time,
                shutdownTime: this.props.record.shutdown_time,
                yellowLightDuration: this.props.record.yellow_light_duration,
                hostMachine: this.props.record.host_machine,
                hostMachineModel: this.props.record.host_machine_model,
                hostMachineIsNetworking: this.props.record.host_machine_is_networking,
                hostMachineProductNumber: this.props.record.host_machine_product_number,
                hostMachineIcode: this.props.record.host_machine_icode,
                hostMachineIp: this.props.record.host_machine_ip,
                hostMachinePort: this.props.record.host_machine_port,
                chassis: this.props.record.chassis,
                isUpsPowerSupply: this.props.record.is_ups_power_supply,
                detachment: this.props.record.detachment,
                region: this.props.record.region,
                road: this.props.record.road,
                operator: this.props.record.operator,
                createYear: this.props.record.create_year?this.props.record.create_year:YEAR,
                longitude: this.props.record.longitude,
                latitude: this.props.record.latitude,
                description: this.props.record.description,
            });
        }
    }
  
    render() {
        return (
            <div>
                <Modal
                    width={800}
                    title={(this.props.record?'修改':'创建') + MODULENAME}
                    open={this.props.isModalOpen}
                    onCancel={this.handleCancel}
                    keyboard={true}
                    okText='确认'
                    cancelText='取消'
                    footer={[
                        <Button key="cancel" disabled={this.state.loading} onClick={this.handleCancel}>取消</Button>,
                        <Button key="ok" type="primary" disabled={this.state.loading} onClick={this.handleOk}>确定</Button>,
                      ]}
                    style={{ top: 0 }}
                    okButtonProps={{ disabled: this.state.loading }}
                >
                    <Row style={{ marginTop: 5, lineHeight: 2.2 }}>
                        <Col span={3}>路口简称：</Col>
                        <Col span={8}>
                            <Input
                                onChange={this.changeName}
                                placeholder='必填字段'
                                value={this.state.name}
                                disabled={this.state.loading}
                            />
                        </Col>
                        <Col span={3} offset={2}>路口编码：</Col>
                        <Col span={8}>
                            <Input
                                onChange={this.changeNumber}
                                placeholder='必填字段'
                                value={this.state.number}
                                disabled={this.state.loading}
                            />
                        </Col>
                    </Row>
                    <Row style={{ marginTop: 5, lineHeight: 2.2 }}>
                        <Col span={3}>路口全称：</Col>
                        <Col span={21}>
                            <Input
                                onChange={this.changeFullName}
                                placeholder='必填字段'
                                value={this.state.fullName}
                                disabled={this.state.loading}
                            />
                        </Col>
                    </Row>
                    <Row style={{ marginTop: 5,lineHeight: 2.2 }}>
                        <Col span={3}>开机时间：</Col>
                        <Col span={8}>
                            <Input
                                onChange={this.changeBootTime}
                                value={this.state.bootTime}
                                disabled={this.state.loading}
                            />
                        </Col>
                        <Col span={3} offset={2}>关机时间：</Col>
                        <Col span={8}>
                            <Input
                                onChange={this.changeShutdownTime}
                                value={this.state.shutdownTime}
                                disabled={this.state.loading}
                            />
                        </Col>
                    </Row>
                    <Row style={{ marginTop: 5, lineHeight: 2.2 }}>
                        <Col span={3}>路口类型：</Col>
                        <Col span={8}>
                            <Input
                                onChange={this.changesStructure}
                                value={this.state.structure}
                                placeholder='比如：十字路口'
                                disabled={this.state.loading}
                            />
                        </Col>
                        <Col span={3} offset={2}>放行方式：</Col>
                        <Col span={8}>
                            <Input
                                onChange={this.changeType}
                                value={this.state.type}
                                placeholder='比如：双向放行'
                                disabled={this.state.loading}
                            />
                        </Col>
                    </Row>
                    <Row style={{ marginTop: 5, lineHeight: 2.2 }}>
                        <Col span={3}>黄灯时间：</Col>
                        <Col span={8}>
                            <InputNumber
                                onChange={this.changeYellowLightDuration}
                                value={this.state.yellowLightDuration}
                                formatter={value => `秒 ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                min={0}
                                max={127}
                                step='1'
                                style={{ width: '100%' }} 
                                disabled={this.state.loading}
                            />
                        </Col>
                        <Col span={3} offset={2}>是否联网：</Col>
                        <Col span={8}>
                            <Radio.Group onChange={this.changeHostMachineIsNetworking} 
                            value={this.state.hostMachineIsNetworking}
                            disabled={this.state.loading}
                            >
                                <Radio value={1}>是</Radio>
                                <Radio value={0}>否</Radio>
                            </Radio.Group>
                        </Col>
                    </Row>
                    <Row style={{ marginTop: 5 }}>
                        <Col span={3} style={{ lineHeight: 2.2 }}>所属区域：</Col>
                        <Col span={8}>
                            <Input
                                onChange={this.changeRegion}
                                value={this.state.region}
                                placeholder='比如：鹤城区'
                                disabled={this.state.loading}
                            />
                        </Col>
                        <Col span={3} offset={2}>运营商：</Col>
                        <Col span={8}>
                            <Input
                                onChange={this.changeOperator}
                                value={this.state.operator}
                                disabled={this.state.loading}
                            />
                        </Col>
                        {/* <Col span={3} offset={2}>所属支队：</Col>
                        <Col span={8}>
                            <Input
                                onChange={this.changeDetachment}
                                value={this.state.detachment}
                                disabled={this.state.loading}
                            />
                        </Col> */}
                    </Row>
                    <Row style={{ marginTop: 5 }}>
                        <Col span={3} style={{ lineHeight: 2.2 }}>信号机品牌：</Col>
                        <Col span={8}>
                            <Input
                                onChange={this.changeHostMachine}
                                value={this.state.hostMachine}
                                disabled={this.state.loading}
                            />
                        </Col>
                        <Col span={3} offset={2} style={{ lineHeight: 2.2 }}>设备型号：</Col>
                        <Col span={8}>
                            <Input
                                onChange={this.changeHostMachineModel}
                                value={this.state.hostMachineModel}
                                disabled={this.state.loading}
                            />
                        </Col>
                    </Row>
                    <Row style={{ marginTop: 5 }}>
                        <Col span={3} style={{ lineHeight: 2.2 }}>机箱：</Col>
                        <Col span={8}>
                            <Input
                                onChange={this.changeChassis}
                                value={this.state.chassis}
                                disabled={this.state.loading}
                            />
                        </Col>
                        <Col span={3} offset={2}>建设年份：</Col>
                        <Col span={8}>
                            <InputNumber
                                onChange={this.changeCreateYear}
                                value={this.state.createYear}
                                min={1949}
                                max={2049}
                                step='1'
                                style={{ width: '100%' }} 
                                disabled={this.state.loading}
                            />
                        </Col>
                    </Row>
                    <Row style={{ marginTop: 5 }}>
                        <Col span={3}>UPS供电：</Col>
                        <Col span={21}>
                            <Radio.Group onChange={this.changeIsUpsPowerSupply} 
                            value={this.state.isUpsPowerSupply}
                            disabled={this.state.loading}
                            >
                                <Radio value={1}>是</Radio>
                                <Radio value={0}>否</Radio>
                            </Radio.Group>
                        </Col>
                    </Row>
                    <Row style={{ marginTop: 5 }}>
                        <Col span={3} style={{ lineHeight: 2.2 }}>主机地址：</Col>
                        <Col span={8}>
                            <Input
                                onChange={this.changeHostMachineIp}
                                value={this.state.hostMachineIp}
                                disabled={this.state.loading}
                            />
                        </Col>
                        <Col span={3} offset={2}>主机端口：</Col>
                        <Col span={8}>
                            <Input
                                onChange={this.changeHostMachinePort}
                                value={this.state.hostMachinePort}
                                disabled={this.state.loading}
                            />
                        </Col>
                    </Row>
                    <Row style={{ marginTop: 5 }}>
                        <Col span={3} style={{ lineHeight: 2.2 }}>产品编码：</Col>
                        <Col span={8}>
                            <Input
                                onChange={this.changeHostMachineProductNumber}
                                value={this.state.hostMachineProductNumber}
                                disabled={this.state.loading}
                            />
                        </Col>
                        <Col span={3} offset={2}>标识编码：</Col>
                        <Col span={8}>
                            <Input
                                onChange={this.changeHostMachineIcode}
                                value={this.state.hostMachineIcode}
                                disabled={this.state.loading}
                            />
                        </Col>
                    </Row>
                    <Row style={{ marginTop: 5 }}>
                        <Col span={3} style={{ lineHeight: 2.2 }}>关联道路：</Col>
                        <Col span={21}>
                            <Input
                                onChange={this.changeRoad}
                                value={this.state.road}
                                placeholder='多条路用逗号（，）隔开'
                                disabled={this.state.loading}
                            />
                        </Col>
                    </Row>
                    <Row style={{ marginTop: 5 }}>
                        <Col span={3} style={{ lineHeight: 2.2 }}>经度：</Col>
                        <Col span={8}>
                            <Input
                                onChange={this.changeLongitude}
                                value={this.state.longitude}
                                disabled={this.state.loading}
                            />
                        </Col>
                        <Col span={3} offset={2}>纬度：</Col>
                        <Col span={8}>
                            <Input
                                onChange={this.changeLatitude}
                                value={this.state.latitude}
                                disabled={this.state.loading}
                            />
                        </Col>
                    </Row>
                    <Row style={{ marginTop: 5 }}>
                        <Col span={3} style={{ lineHeight: 2.2 }}>备注：</Col>
                        <Col span={21}>
                            <TextArea
                                placeholder='备注可写在这里...'
                                autoSize={{ minRows: 2, maxRows: 4 }}
                                onChange={this.changeDescription}
                                disabled={this.state.loading}
                                value={this.state.description}
                            />
                        </Col>
                    </Row>
                </Modal>
            </div>
        );
    }
}

export default Entity